import script from "./SecondaryTop.vue?vue&type=script&setup=true&lang=js"
export * from "./SecondaryTop.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import BackLink from "@/components/BackLink.vue";
import BasicSpinner from "@/components/BasicSpinner.vue";
import InputField from "@/components/neue/InputField.vue";
import NeueButton from "@/components/neue/NeueButton.vue";
import NeueTabs from "@/components/neue/NeueTabs.vue";
script.components = Object.assign({}, { BackLink, BasicSpinner, InputField, NeueButton, NeueTabs }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { BackLink, BasicSpinner, InputField, NeueButton, NeueTabs }, script.__o.components);}